// if type == formblock follow reference
// _type == "formBlock" => ^->
export const defaultBlock = /* groq */ `
    ...,
    markDefs[]{
      ...,
      internalPage->{
        _type,
        slug{
            current
        }
      },
      file{
        asset->{
          url
        }
      }
    },
    _type == "formBlock" => {
        title,
        form->{
            _id,
            title,
            slug,
            overrideTitle,
            inactive,
            copy[],
            confirmationCopy[],
            inactiveCopy[],
            inputs[] {
                ...,
            }
        }
    },
    _type == "accordionBlock" => {
        accordionContent[]{
            title,
            "slug": slug.current,
            content[]{
                ...,
                markDefs[]{
                    ...,
                    internalPage->{
                        _type,
                        slug{
                            current
                        }
                    },
                    file{
                        asset->{
                        url,
                        originalFilename
                        }
                    }
                }
            }
        },
    },
    _type == "partnersBlock" => {
        pttrColumn1[]{
            ...
        },
        pttrColumn2[]{
            ...
        },
        pttrColumn3[]{
            ...
        },
        pttrColumn4[]{
            ...
        },
    },
`
